import { keys, transform } from 'lodash-es';

import type { ITreeItem } from '@components/tree/VTree/types';

import type { IPermissionsKeyMap } from '../types';

export default function buildTreeItems(permissionsTree?: IPermissionsKeyMap): ITreeItem[] {
  if (!permissionsTree)
    return [];

  return transform<string, ITreeItem[]>(
    keys(permissionsTree).sort((a, b) => a.localeCompare(b, 'en')),
    (acc, groupName) => {
      acc.push({
        label: groupName,
        key: groupName,
        path: groupName,
        children: [...permissionsTree[groupName].slice().sort((a, b) => a.localeCompare(b, 'en')).map((permission) => ({
          label: permission,
          key: permission,
          path: groupName,
        }))],
      });
    },
    [],
  );
}
